import { TableCell, TableRow, makeStyles } from '@material-ui/core';

import { useLabelFilters } from '@spotify/confidence-common-react';
import {
  StickyTableHeadMui as StickyTableHead,
  TableSortLabel,
} from '@spotify/confidence-core-react';

const useStyles = makeStyles({
  labelsCell: {
    maxWidth: 0,
    overflow: 'hidden',
  },
});

export const headerFields = {
  name: 'displayName',
  state: 'state',
  created: 'createTime',
  updated: 'updateTime',
  owner: 'owner',
} as const;

export const WorkflowInstanceTableHeader = ({
  topOffset,
  sort,
  isSortingActive,
  getSortingDirection,
}: {
  topOffset?: number;
  sort: (field: string) => void;
  isSortingActive: (field: string) => boolean;
  getSortingDirection: (field: string) => 'asc' | 'desc' | undefined;
}) => {
  const classes = useStyles();
  const { labelDefinitions } = useLabelFilters();
  const hasLabels = labelDefinitions.length > 0;

  return (
    <StickyTableHead topOffset={topOffset}>
      <TableRow>
        <TableCell width={hasLabels ? '38%' : '50%'}>
          <TableSortLabel
            hideInactiveIcon
            active={isSortingActive(headerFields.name)}
            direction={getSortingDirection(headerFields.name)}
            onClick={() => sort(headerFields.name)}
           data-track-source-anchor="8e2255b008;;low">
            Name
          </TableSortLabel>
        </TableCell>
        <TableCell width="8%">
          <TableSortLabel
            hideInactiveIcon
            active={isSortingActive(headerFields.state)}
            direction={getSortingDirection(headerFields.state)}
            onClick={() => sort(headerFields.state)}
           data-track-source-anchor="a2c9a2cec8;;low">
            State
          </TableSortLabel>
        </TableCell>
        <TableCell width="16%">Progress</TableCell>
        <TableCell width="11%">
          <TableSortLabel
            hideInactiveIcon
            active={isSortingActive(headerFields.updated)}
            direction={getSortingDirection(headerFields.updated)}
            onClick={() => sort(headerFields.updated)}
           data-track-source-anchor="b07cc0a00f;;low">
            Updated
          </TableSortLabel>
        </TableCell>
        <TableCell width={hasLabels ? '12%' : '15%'}>
          <TableSortLabel
            hideInactiveIcon
            active={isSortingActive(headerFields.owner)}
            direction={getSortingDirection(headerFields.owner)}
            onClick={() => sort(headerFields.owner)}
           data-track-source-anchor="c61336c630;;low">
            Owner
          </TableSortLabel>
        </TableCell>
        {hasLabels && (
          <TableCell width="15%" className={classes.labelsCell}>
            Labels
          </TableCell>
        )}
      </TableRow>
    </StickyTableHead>
  );
};
